import { render } from "./groupbarchartscreening.vue?vue&type=template&id=4111e63a&scoped=true"
import script from "./groupbarchartscreening.vue?vue&type=script&lang=js"
export * from "./groupbarchartscreening.vue?vue&type=script&lang=js"

import "./groupbarchartscreening.vue?vue&type=style&index=0&id=4111e63a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4111e63a"]])

export default __exports__